import { fromJS, Map } from 'immutable';

import { requestSubmittedReturnDetails } from './actions';
import { requestOrderDetails } from '../actions';

export const defaultState = Map({
  isFetching: false,
  returnDetails: {},
  isFetchingOrderDetails: false
});

export default function returnDetails(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case requestSubmittedReturnDetails.event.start:
      return newState.set('isFetching', true);

    case requestSubmittedReturnDetails.event.success:
      return newState.withMutations(state => {
        state.set('isFetching', false).set('returnDetails', action.payload);
      });

    case requestSubmittedReturnDetails.event.error:
      return newState.withMutations(state => {
        state.set('isFetching', false).set('returnDetails', {});
      });

    case requestOrderDetails.event.start:
      return newState.set('isFetchingOrderDetails', true);

    case requestOrderDetails.event.success:
    case requestOrderDetails.event.error:
      return newState.set('isFetchingOrderDetails', false);

    default:
      return newState;
  }
}

export const isFetching = state => state.returnDetails.get('isFetching');
export const getReturnDetails = state => state.returnDetails.get('returnDetails');
export const getIsFetchingOrderDetails = state => state.returnDetails.get('isFetchingOrderDetails');
